import React from "react";
import MapTo from "../../utils/mapto";
import styled from "styled-components";

const StyledContainer = styled.div`
    background: ${props => props.backgroundColor || 'transparent'};
    box-shadow: ${props => props.backgroundShadow || 'none'};
`;

const Card1 = (props) => {
    const items = props?.items || props?.content?.items;
    const backgroundColor = props.backgroundColor || (props.content && props.content.backgroundColor);
    const backgroundShadow = props.backgroundShadow || (props.content && props.content.backgroundShadow);
    const borderRadius = props.borderRadius || (props.content && props.content.borderRadius);
    const borderRadiusTop = props.borderRadiusTop || (props.content && props.content.borderRadiusTop);
    const borderRadiusBottom = props.borderRadiusBottom || (props.content && props.content.borderRadiusBottom);

    // Separate media and content items
    const mediaItems = items?.filter(item => item.__typename === "ContentfulMedia") || [];
    const contentItems = items?.filter(item => item.__typename !== "ContentfulMedia") || [];

    return (
        <StyledContainer
            backgroundColor={backgroundColor}
            backgroundShadow={backgroundShadow}
            className={`card1 flex-1 flex items-center justify-start pl-[0] pr-[16px] lg:px-[16px] py-[8px] ${borderRadius ? ` rounded-all_48` : ''}${borderRadiusTop ? ` rounded-top_48` : ''}${borderRadiusBottom ? ` rounded-bottom_48` : ''}`}
        >
            {mediaItems.length > 0 && (
                <div className="card1__media">
                    {mediaItems.map(item => (
                        <MapTo key={item.id} items={item} className="max-w-[100px] lg:max-w-max_content" />
                    ))}
                </div>
            )}

            {contentItems.length > 0 && (
                <div className="card1__content lg:pr-[16px] flex flex-col flex-[1,0,0] gap-[8px] lg:gap-[16px]">
                    {contentItems.map(item => (
                        <MapTo key={item.id} items={item} />
                    ))}
                </div>
            )}
        </StyledContainer>
    );
};

export default Card1; 